<div class="container-fluid">
    <div class="row">
        <div class="col-md-12 text-center">
            <h1>XAUUSD</h1>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <highcharts-chart [Highcharts]="Highcharts" [constructorType]="chartConstructor" [options]="chartOptions"
                [(update)]="updateFlag" [oneToOne]="oneToOneFlag" [runOutsideAngular]="runOutsideAngularFlag"
                style="width: 100%; height: 600px; display: block;"></highcharts-chart>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12 text-center">
            <h1>BackTest</h1>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <highcharts-chart [Highcharts]="Highcharts" [constructorType]="chartConstructor" [options]="chartOptions2"
                [(update)]="updateFlag" [oneToOne]="oneToOneFlag" [runOutsideAngular]="runOutsideAngularFlag"
                style="width: 100%; height: 600px; display: block;"></highcharts-chart>
        </div>
    </div>
    <div class="row mt-5">
        <div class="col-md-6 ">
            <h1>Risultati</h1>
            <app-trading-system-summary [ts]="ts"></app-trading-system-summary>
        </div>
        <div class="col-6">
            <app-trading-system-grafico-weekly #chartWeek
                [titolo]="'Trading System Weekly'"></app-trading-system-grafico-weekly>
        </div>
    </div>
    <div class="row mt-5">
        <div class="col-6">
            <app-trading-system-grafico-weekly #chartBuy
                [titolo]="'Trading System Weekly Buy'"></app-trading-system-grafico-weekly>
        </div>
        <div class="col-6">
            <app-trading-system-grafico-weekly #chartSell
                [titolo]="'Trading System Weekly Sell'"></app-trading-system-grafico-weekly>
        </div>
    </div>
    <div class="row mt-5">
        <div class="col-12">
            <app-trading-system-grafico-weekly #chartMonth
                [titolo]="'Trading System Monthly'"></app-trading-system-grafico-weekly>
        </div>
    </div>
    
    <div class="row mt-5">
        <div class="col-6">
            <app-trading-system-grafico-weekly #chartMonthlyBuy
                [titolo]="'Trading System Monthly Buy'"></app-trading-system-grafico-weekly>
        </div>
        <div class="col-6">
            <app-trading-system-grafico-weekly #chartMonthlySell
                [titolo]="'Trading System Monthly Sell'"></app-trading-system-grafico-weekly>
        </div>
    </div>
</div>
